import PropTypes from "prop-types"

import ActivityAttributeShape from "./shapes/ActivityAttributeShape"

const properties = {
  createdAt: PropTypes.string.isRequired,
  createdBy: PropTypes.string,
  id: PropTypes.string.isRequired,
  investorAccountId: PropTypes.string,
  mutationAttributes: PropTypes.arrayOf(ActivityAttributeShape),
  operationId: PropTypes.string.isRequired,
  parametersJson: PropTypes.string,
  queryAttributes: PropTypes.arrayOf(ActivityAttributeShape),
  resultAttributes: PropTypes.arrayOf(ActivityAttributeShape),
  resultJson: PropTypes.string,
  template: PropTypes.string.isRequired,
  updatedAt: PropTypes.string,
  updatedBy: PropTypes.string,
  userId: PropTypes.string.isRequired
}

const ReadActivityOutputShapeShape = PropTypes.exact(properties)

export default ReadActivityOutputShapeShape
export { properties }
